module.exports = __webpack_public_path__ + "media/images/まとめ買い割引_500円_1280_480-3f57cec3ff4ffb440d5ecc08c4868f58.png";